import { Component, OnInit } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'location-switcher',
  templateUrl: './location-switcher.component.html',
  styleUrls: ['./location-switcher.component.scss']
})
export class LocationSwitcherComponent implements OnInit {

  constructor(public shared: Shared) { }

  ngOnInit() {
  }

  setLoc(location){
    this.shared.userRef.update({location : location.$key});
  }

  say(hi){
    //console.log(hi);
  }

  logOut(){
      this.shared.afAuth.auth.signOut();
  }

}



// WEBPACK FOOTER //
// ./src/app/location-switcher/location-switcher.component.ts